import { SUBCLUSTERS } from '../subclusters.js';

const OPERATIONS_CLUSTER = {
    subclusters: [
        {
            key: SUBCLUSTERS.PROJECT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.OPERATIONS_PROCESSES,
        },
        {
            key: SUBCLUSTERS.EVENT_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.REMOTE_WORK,
        },
        {
            key: SUBCLUSTERS.MARKETING_OPERATIONS,
        },
        {
            key: SUBCLUSTERS.TASKS,
        },
        {
            key: SUBCLUSTERS.RESOURCE_MANAGEMENT,
        },
        {
            key: SUBCLUSTERS.REPORTING_TO_EXECUTIVES,
        },
        {
            key: SUBCLUSTERS.MANAGING_PROJECTS_PORTFOLIO,
        },
        {
            key: SUBCLUSTERS.MANAGING_ROUTINE_PROCESSES,
        },
        {
            key: SUBCLUSTERS.BUSINESS_OPERATIONS,
        },
        {
            key: SUBCLUSTERS.CRM,
        },
        {
            key: SUBCLUSTERS.SOFTWARE_DEVELOPMENT,
        },
    ],
};

export { OPERATIONS_CLUSTER };
